import "bootstrap";
import "./style.scss";
import "./import-jquery";
import "./main.js";
import "waypoints/lib/jquery.waypoints.min.js";
